import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M 26 56 l 1.6 8.4 s 3.6 2 8.8 2 c 5.84 0 12.24 -2.88 12.24 -8.56 c 0 -12.32 -28.88 -7.2 -28.88 -26.32 c 0 -11.2 8.96 -15.92 18.96 -15.92 c 7.6 0 16.88 3.2 16.88 3.2 l -0.4 13.6 l -5.2 0 l -2.72 -8.56 s -4.08 -1.44 -8.48 -1.44 c -7.2 0 -10.64 3.76 -10.64 7.76 c 0 12.16 28.8 7.52 28.8 25.52 c 0 12 -9.68 17.52 -20.88 17.52 c -8.4 0 -16.48 -3.2 -16.48 -3.2 l 0 -14 l 6.4 0 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
